export default __webpack_public_path__ + "maps-examples-switch-styles-thumbnail-480-1f449a537d22385911be310a7d8bb6cf.webp";